import React from "react";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

import { V2 } from "../../Api";
import withTitle from "../withTitle";

import HasRight from "../HasRight";
import ViewToolbar from "../ViewToolbar";

import "../../blocks.css";
import "../../icomoon.css";
import "../../indicator.css";
import "../../list.css";
import "../../spinner.css";
import "../../table.css";
import "../../user.css";
import "../viewer.css";

interface ILocationsViewState {
    isLoading: boolean;
    error?: string;
    locations: any[];
    filteredLocations: any[];
    searchText: string;
}

class LocationsView extends React.Component<{}, ILocationsViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            isLoading: false,
            locations: [],

            filteredLocations: [],
            searchText: ""
        };

        this.changeSearchChange = this.changeSearchChange.bind(this);
    }

    public async componentDidMount() {
        try {
            this.setState({
                error: undefined,
                isLoading: true
            });
            const locations = await V2.get<any[]>("locations");

            this.setState({
                filteredLocations: locations,
                isLoading: false,
                locations,
            });
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <HasRight right="location:create">
                        <Link to="/locations/add" className="icon-plus" />
                    </HasRight>
                </ViewToolbar>
                <div className="filter-control-box">
                    <input type="search" className="fill-space" placeholder="Search..." value={this.state.searchText} onChange={this.changeSearchChange} />
                </div>

                <div className="table-viewer-nomobile">
                    <table className="table-vertical wrap">
                        <thead>
                            <tr>
                                <th className="col-smallest" />
                                <th>Name</th>
                                <th>Nickname</th>
                                <th>Type</th>
                                <th>Street Address</th>
                                <th>City</th>
                                <th>State</th>
                                <th className="col-smallest">Zip</th>
                                <th className="col-smallest" />
                            </tr>
                        </thead>
                        <thead className="table-vertical-head-small">
                            <tr>
                                <th>Locations</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.isLoading ?
                                    <tr>
                                        <td colSpan={10}>
                                            <div className="spinner-center lds-dual-ring" />
                                        </td>
                                    </tr>
                                    : this.state.filteredLocations.map(a => (
                                        <tr key={a.id}>
                                            <td><span className={`indicator cal-event-${a.color}`}>&nbsp;&nbsp;&nbsp;</span></td>
                                            <td data-caption="Name: " className="col-200px-ellipse">{a.name}</td>
                                            <td data-caption="Nickname: ">{a.shortName}</td>
                                            <td data-caption="Type: ">{this.officeTypeToString(a.type)}</td>
                                            <td data-caption="Address: ">
                                                {a.address.street}
                                                {/*`${a.address.street}, ${a.address.city}, ${a.address.state} ${a.address.zip}`*/}
                                            </td>
                                            <td>{a.address.city}</td>
                                            <td className="col-smallest col-center">{a.address.state}</td>
                                            <td className="col-smallest">{a.address.zip}</td>
                                            <td>
                                                <HasRight right="location:write">
                                                    <Link to={`/locations/${a.id}`} className="button small text-with-icon">
                                                        <span>Edit</span>
                                                        <i className="icon-chevron-right" />
                                                    </Link>
                                                </HasRight>
                                            </td>
                                        </tr>
                                    ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private changeSearchChange(e: ChangeEvent<HTMLInputElement>) {
        const searchValue = e.currentTarget.value;
        this.setState(s => {
            return {
                searchText: searchValue,

                filteredLocations: searchValue ? s.locations.filter(u =>
                    u.shortName.toLowerCase().includes(searchValue.toLowerCase()) ||
                    u.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                    u.address.street.toLowerCase().includes(searchValue.toLowerCase()) ||
                    u.address.city.toLowerCase().includes(searchValue.toLowerCase()) ||
                    u.address.state.toLowerCase().includes(searchValue.toLowerCase()) ||
                    u.address.zip.toLowerCase().includes(searchValue.toLowerCase())
                ) : s.locations
            }
        });
    }

    private officeTypeToString(type: string) {
        switch (type) {
            case "office": return "Office";
            case "surgery": return "Surgery Center";
            default: return type;
        }
    }
}

export default withTitle("UOG Locations", LocationsView);
